export default "__VITE_ASSET__ee76a7fe__"